"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiRequestTypeEnum = void 0;
var AiRequestTypeEnum;
(function (AiRequestTypeEnum) {
    AiRequestTypeEnum["KbAssistant"] = "KbAssistant";
})(AiRequestTypeEnum = exports.AiRequestTypeEnum || (exports.AiRequestTypeEnum = {}));
